import { render } from "./StampComplete.vue?vue&type=template&id=4087577d&scoped=true"
import script from "./StampComplete.vue?vue&type=script&lang=js"
export * from "./StampComplete.vue?vue&type=script&lang=js"

import "./StampComplete.vue?vue&type=style&index=0&id=4087577d&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4087577d"]])

export default __exports__